import { render } from "./location.vue?vue&type=template&id=e1715680&scoped=true"
import script from "./location.vue?vue&type=script&lang=js"
export * from "./location.vue?vue&type=script&lang=js"

import "./location.vue?vue&type=style&index=0&id=e1715680&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1715680"]])

export default __exports__